module.exports = __webpack_public_path__ + "img/3.b37fe10c.jpg";